import type { Config } from './types';

export const Development: Partial<Config> = {
  GEM_HOST: 'https://localhost:3000',
  LAUNCHDARKLY_CLIENT_SIDE_ID: '63617372d7adf90c5166fb00',
  LEVER_HOST: 'https://hire.sandbox.lever.co',
  SEGMENT_WRITE_KEY: 'XBdRMXlaS5hL7M8cvdFoG82R7fcOaxo7',
};
